export const SESSION_DETAILS_PAGE_SIZE = 50;
